module.exports = __webpack_public_path__ + "static/media/big-red-exclamation-icon.e4e48386.svg";